import { TextField, TextFieldProps } from '@mui/material';
import './Input.scss';

export type InputProps = Omit<TextFieldProps, 'label' | 'error' | 'size'> & {
  name: string;
  label?: string;
  error?: boolean;
  className?: string;
};

export function Input({ name, label, error, id, className, ...rest }: InputProps) {
  const inputId = id ?? `input-${name}`;

  return (
    <div className={`input ${className ?? ''}`.trim()}>
      {label && <label className="input__label" htmlFor={inputId}>{label}</label>}

      <TextField
        id={inputId}
        name={name}
        className="input__field"
        variant="outlined"
        fullWidth
        error={Boolean(error)}
        helperText={error || ' '}
        {...rest}
      />
    </div>
  );
}

export default Input;
